module.exports = __webpack_public_path__ + "static/media/diktat-35.f9db1de9.mp3";